import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  // Uses the same key as layout.component.ts, profile-details, and auth components
  // so all theme writes across the app remain consistent without rewriting all callers.
  private readonly STORAGE_KEY = 'darKMode';
  private readonly SWITCH_CLASS = 'theme-switching';
  isDark = false;

  init(): void {
    this.isDark = localStorage.getItem(this.STORAGE_KEY) === 'active';
    this.apply();
  }

  toggle(): void {
    this.isDark = !this.isDark;
    if (this.isDark) {
      localStorage.setItem(this.STORAGE_KEY, 'active');
    } else {
      localStorage.removeItem(this.STORAGE_KEY);
    }
    this.applyWithTransition();
  }

  private apply(): void {
    document.body.classList.toggle('darkmode', this.isDark);
  }

  private applyWithTransition(): void {
    document.body.classList.add(this.SWITCH_CLASS);
    this.apply();
    setTimeout(() => document.body.classList.remove(this.SWITCH_CLASS), 400);
  }

  get currentTheme(): string {
    return this.isDark ? 'dark' : 'default';
  }

  loadTheme(firstLoad = true): Promise<void> {
    if (firstLoad) this.init();
    return Promise.resolve();
  }

  toggleTheme(): Promise<void> {
    this.toggle();
    return Promise.resolve();
  }
}
